import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ThemeService {
  idVisual = {
    urlLogo: '',
    urlBackground: '',
    domain: [],
    cores: {
      corPrincipal: '',
      corDefault: '',
      corPrimary: '',
      corInfo: '',
      corSuccess: '',
      corWarning: '',
      corDanger: '',
      corRose: '',
      corGraficos: '',
      usarCorSecundariaNosBotoes: false,
    }
  };

  constructor() { }

  public async init() {
    const idVisualLocal: any = JSON.parse(localStorage.getItem('idVisual'));

    if (idVisualLocal) {
      this.idVisual = idVisualLocal;
      this.idVisual.domain = this.generateMonoColorPalette(idVisualLocal.cores.corGraficos);
    } else {
      const configuracao = JSON.parse(localStorage.getItem('configuracao'));

      if (!configuracao) {
        return;
      }

      this.idVisual.domain = configuracao.esquemaDeCores.domain;
    }

    localStorage.setItem('idVisual', JSON.stringify(this.idVisual));
    this.injetarTema();
  }

  public injectCSSClass(cssClass: string) {
    const head = document.getElementsByTagName('head')[0];
    const style = document.createElement('style');
    style.type = 'text/css';
    style.appendChild(document.createTextNode(cssClass));
    head.appendChild(style);
  }

  public injetarTema() {
    this.injectCSSClass(`
        .sidebar { background: ${this.idVisual.cores.corPrincipal} !important; }
        .sidebar::before { background-color: ${this.idVisual.cores.corPrincipal};}

        .grid .destaque {
          background: ${this.idVisual.urlBackground ? `url(${this.idVisual.urlBackground}) no-repeat center` : this.idVisual.cores.corPrincipal}  !important;
          background-size: cover !important;
        }

        .logo-principal {
          width: 400px;
          min-height: 200px;
          margin-bottom: 10px;
          background: url(${this.idVisual.urlLogo}) no-repeat center !important;
          background-size: contain !important;
        }

        .login-page {
          background-color: ${this.idVisual.cores.corPrincipal} !important;
          background: ${this.idVisual.cores.corPrincipal} !important;
        }

        .navbar-brand {
          background: linear-gradient(60deg, #f7b32b, #f49d04) !important;
        }

        ${this.idVisual.cores.usarCorSecundariaNosBotoes ? `
            .navbar-brand {
              background: linear-gradient(60deg, ${this.idVisual.cores.corPrimary}, ${this.escurecerCor(this.idVisual.cores.corPrimary, 0.9)}) !important;
            }

            .radio-button-v2 .radio-button-v2-selecionado .mat-radio-label-content {
              color: ${this.idVisual.cores.corPrimary} !important;
            }

            .alert.alert-primary {
              background-color: ${this.idVisual.cores.corPrimary} !important;
              box-shadow: 0 4px 20px 0px ${this.hexToRgba(this.idVisual.cores.corPrimary, 0.14)}, 0 7px 10px -5px ${this.hexToRgba(this.idVisual.cores.corPrimary, 0.4)};
            }

            .panel-primary-light {
              border-radius: 14px;
              color: color-mix(in srgb, ${this.idVisual.cores.corPrimary} 65%, black);
              background-color: color-mix(in srgb, ${this.idVisual.cores.corPrimary} 15%, white);
              border: 1px color-mix(in srgb, ${this.idVisual.cores.corPrimary} 65%, black) solid;
              padding: 8px 16px;
            }

            .mat-button.btn.btn-info, .mat-raised-button.btn.btn-info, .mat-raised-button.btn:not([class*=mat-elevation-z]).btn-info, .btn.btn-info {
              background-color: ${this.idVisual.cores.corInfo} !important;
              background: ${this.idVisual.cores.corInfo} !important;
            }

            .card .card-header-primary .card-icon, .card .card-header-primary .card-text, .card .card-header-primary:not(.card-header-icon):not(.card-header-text), .card.bg-primary, .card.card-rotate.bg-primary .front, .card.card-rotate.bg-primary .back {
              background: linear-gradient(60deg, ${this.idVisual.cores.corPrimary}, ${this.escurecerCor(this.idVisual.cores.corPrimary, 0.9)}) !important;
              box-shadow: 0 4px 20px 0px ${this.hexToRgba(this.idVisual.cores.corPrimary, 0.14)}, 0 7px 10px -5px ${this.hexToRgba(this.idVisual.cores.corPrimary, 0.4)};
            }

            .card .card-header-success .card-icon, .card .card-header-success .card-text, .card .card-header-success:not(.card-header-icon):not(.card-header-text), .card.bg-success, .card.card-rotate.bg-success.front, .card.card-rotate.bg-success .back {
              background: linear-gradient(60deg, ${this.idVisual.cores.corSuccess}, ${this.escurecerCor(this.idVisual.cores.corSuccess, 0.9)}) !important;
              box-shadow: 0 4px 20px 0px ${this.hexToRgba(this.idVisual.cores.corSuccess, 0.14)}, 0 7px 10px -5px ${this.hexToRgba(this.idVisual.cores.corSuccess, 0.4)};
            }

            .card .card-header-info .card-icon, .card .card-header-info .card-text, .card .card-header-info:not(.card-header-icon):not(.card-header-text), .card.bg-info, .card.card-rotate.bg-info .front, .card.card-rotate.bg-info .back {
              background: linear-gradient(60deg, ${this.idVisual.cores.corInfo}, ${this.escurecerCor(this.idVisual.cores.corInfo, 0.9)}) !important;
              box-shadow: 0 4px 20px 0px ${this.hexToRgba(this.idVisual.cores.corInfo, 0.14)}, 0 7px 10px -5px ${this.hexToRgba(this.idVisual.cores.corInfo, 0.4)};
            }

            .card2__input:checked .card2__body {
              --shadow: ${this.idVisual.cores.corInfo} !important;
            }

            .mat-button.btn.btn-primary, .mat-raised-button.btn.btn-primary, .mat-raised-button.btn:not([class*=mat-elevation-z]).btn-primary, .btn.btn-primary {
              background-color: ${this.idVisual.cores.corPrimary} !important;
              border-color: ${this.idVisual.cores.corPrimary};
              box-shadow: 0 4px 20px 0px ${this.hexToRgba(this.idVisual.cores.corPrimary, 0.14)}, 0 7px 10px -5px ${this.hexToRgba(this.idVisual.cores.corPrimary, 0.4)};
            }

            .badge-primary {
              background-color: ${this.idVisual.cores.corPrimary} !important;
            }

            .badge-info {
              background-color: ${this.idVisual.cores.corInfo} !important;
            }

            .mat-button.btn.btn-info:focus, .mat-button.btn.btn-info:active, .mat-button.btn.btn-info:hover, .mat-raised-button.btn.btn-info:focus, .mat-raised-button.btn.btn-info:active, .mat-raised-button.btn.btn-info:hover, .mat-raised-button.btn:not([class*=mat-elevation-z]).btn-info:focus, .mat-raised-button.btn:not([class*=mat-elevation-z]).btn-info:active, .mat-raised-button.btn:not([class*=mat-elevation-z]).btn-info:hover, .btn.btn-info:focus, .btn.btn-info:active, .btn.btn-info:hover {
              background-color: ${this.idVisual.cores.corInfo} !important;
              border-color: ${this.idVisual.cores.corInfo};
              box-shadow: 0 4px 20px 0px ${this.hexToRgba(this.idVisual.cores.corInfo, 0.14)}, 0 7px 10px -5px ${this.hexToRgba(this.idVisual.cores.corInfo, 0.4)};
            }

            .mat-button.btn.btn-success, .mat-raised-button.btn.btn-success, .mat-raised-button.btn:not([class*=mat-elevation-z]).btn-success, .btn.btn-success {
              background-color: ${this.idVisual.cores.corSuccess} !important;
            }

            .mat-button.btn.btn-success:focus, .mat-button.btn.btn-success.focus, .mat-button.btn.btn-success:hover, .mat-raised-button.btn.btn-success:focus, .mat-raised-button.btn.btn-success.focus, .mat-raised-button.btn.btn-success:hover, .mat-raised-button.btn:not([class*=mat-elevation-z]).btn-success:focus, .mat-raised-button.btn:not([class*=mat-elevation-z]).btn-success.focus, .mat-raised-button.btn:not([class*=mat-elevation-z]).btn-success:hover, .btn.btn-success:focus, .btn.btn-success.focus, .btn.btn-success:hover {
              background-color: ${this.escurecerCor(this.idVisual.cores.corSuccess, 0.9)};
            }

            .mat-button.btn.btn-primary:focus, .mat-button.btn.btn-primary:active, .mat-button.btn.btn-primary:hover, .mat-raised-button.btn.btn-primary:focus, .mat-raised-button.btn.btn-primary:active, .mat-raised-button.btn.btn-primary:hover, .mat-raised-button.btn:not([class*=mat-elevation-z]).btn-primary:focus, .mat-raised-button.btn:not([class*=mat-elevation-z]).btn-primary:active, .mat-raised-button.btn:not([class*=mat-elevation-z]).btn-primary:hover, .btn.btn-primary:focus, .btn.btn-primary:active, .btn.btn-primary:hover {
              box-shadow: 0 4px 20px 0px ${this.hexToRgba(this.idVisual.cores.corPrimary, 0.14)}, 0 7px 10px -5px ${this.hexToRgba(this.idVisual.cores.corPrimary, 0.4)};
            }

            .text-default {
              color: ${this.idVisual.cores.corDefault} !important;
            }

            .text-primary {
              color: ${this.idVisual.cores.corPrimary} !important;
            }

            .text-info {
              color: ${this.idVisual.cores.corInfo} !important;
            }

            .text-success {
              color: ${this.idVisual.cores.corSuccess} !important;
            }

            .text-danger {
              color: ${this.idVisual.cores.corDanger} !important;
            }

            .text-rose {
              color: ${this.idVisual.cores.corRose} !important;
            }

            .bg-primary {
              background-color: ${ this.idVisual.cores.corPrimary } !important;
            }

            .bg-primary-light {
              background-color:${ this.hexToRgba(this.idVisual.cores.corPrimary, 0.14) } !important;
            }

            .btn-outline-primary-v2 {
              border-color: ${ this.idVisual.cores.corPrimary } !important;
              background-color: #fff !important;
              color: ${ this.idVisual.cores.corPrimary } !important;
            }

            .btn-outline-info-v2 {
              border-color: ${ this.idVisual.cores.corInfo } !important;
              background-color: #fff !important;
              color: ${ this.idVisual.cores.corInfo } !important;
            }

            .badge-primary {
              background-color: ${this.idVisual.cores.corPrimary} !important;
            }

            .badge-info {
              background-color: ${this.idVisual.cores.corInfo} !important;
            }

            .badge-success {
              background-color: ${this.idVisual.cores.corSuccess} !important;
            }

            .badge-danger {
              background-color: ${this.idVisual.cores.corDanger} !important;
            }

            .badge-danger {
              background-color: ${this.idVisual.cores.corDanger} !important;
            }

            a {
                color: ${this.idVisual.cores.corPrimary};
            }

            a:hover, a:focus {
                color: ${this.clarearCor(this.idVisual.cores.corPrimary, 0.9)};
            }

            .iconeTitulo {
              .icon {
                background-color: ${this.idVisual.cores.corPrimary} !important;
              }
            }

            .card-wizard[data-color=purple] .moving-tab {
              background-color: ${this.idVisual.cores.corPrimary} !important;
              box-shadow: 0 4px 20px 0px ${this.hexToRgba(this.idVisual.cores.corPrimary, 0.14)}, 0 7px 10px -5px ${this.hexToRgba(this.idVisual.cores.corPrimary, 0.4)};
            }

            .togglebutton label input[type=checkbox]:checked + .toggle {
              background-color: ${this.idVisual.cores.corInfo} !important;

              &:after {
                border-color: ${this.idVisual.cores.corInfo};
              }
            }

            .sidebar[data-color="white"]
              .nav
              .nav-item.active
              > a:not([data-toggle="collapse"])
              .material-icons {
              color: ${this.isColorLight(this.idVisual.cores.corPrimary) ? this.idVisual.cores.corPrimary : this.clarearCor(this.idVisual.cores.corPrimary, 0.8)} !important;
              }

            .mat-radio-button.mat-accent .mat-radio-inner-circle, .mat-radio-button.mat-accent .mat-radio-ripple .mat-ripple-element:not(.mat-radio-persistent-ripple), .mat-radio-button.mat-accent.mat-radio-checked .mat-radio-persistent-ripple, .mat-radio-button.mat-accent:active .mat-radio-persistent-ripple {
              background-color: ${this.idVisual.cores.corInfo} !important;
            }

            .mat-form-field.mat-focused .mat-form-field-ripple {
                background-color: ${this.isColorLight(this.idVisual.cores.corPrimary) ? this.idVisual.cores.corPrimary : this.clarearCor(this.idVisual.cores.corPrimary, 0.8)} !important;
            }

            .dropdown-menu .dropdown-item:focus, .dropdown-menu .dropdown-item:hover, .dropdown-menu a:active, .dropdown-menu a:focus, .dropdown-menu a:hover {
                background-color:  ${this.isColorLight(this.idVisual.cores.corPrimary) ? this.idVisual.cores.corPrimary : this.clarearCor(this.idVisual.cores.corPrimary, 0.8)} !important;
            }

            .form-check .form-check-input:checked + .form-check-sign .check {
                background: ${this.idVisual.cores.corPrimary} !important;
            }

            .mat-radio-button.mat-accent .mat-radio-inner-circle,
            .mat-radio-button.mat-accent
              .mat-radio-ripple
              .mat-ripple-element:not(.mat-radio-persistent-ripple),
            .mat-radio-button.mat-accent.mat-radio-checked .mat-radio-persistent-ripple,
            .mat-radio-button.mat-accent:active .mat-radio-persistent-ripple {
              background-color: ${this.idVisual.cores.corPrimary} !important;
            }

            .togglebutton label input[type="checkbox"]:checked + .toggle {
                &:after {
                    border-color: ${this.idVisual.cores.corPrimary} !important;
                }
            }

            .togglebutton label input[type=checkbox]:checked + .toggle {
                background-color: ${this.idVisual.cores.corPrimary} !important;
            }

            .togglebutton label input[type=checkbox]:checked + .toggle:active:after {
                box-shadow: 0 1px 3px 1px rgba(0, 0, 0, 0.4), 0 0 0 15px ${this.hexToRgba(this.idVisual.cores.corPrimary, 0.1)} !important;
            }

            input[type="checkbox"] {
              accent-color: ${this.idVisual.cores.corPrimary} !important;
            }

            .primary-progress .mat-progress-bar-fill::after {
              background-color: ${this.idVisual.cores.corPrimary} !important;
            }

            .primary-progress .mat-progress-bar-buffer {
              background-color: color-mix(in srgb, ${this.idVisual.cores.corPrimary} 45%, white) !important;
            }

            .primary-progress .mat-progress-bar-background {
                fill: color-mix(in srgb, ${this.idVisual.cores.corPrimary} 45%, white) !important;
            }


          ` : ''}
    `);
  }

  escurecerCor(hex, fator) {
    if (hex.includes('gradient')) return hex;

    let [r, g, b] = [parseInt(hex.slice(1, 3), 16), parseInt(hex.slice(3, 5), 16), parseInt(hex.slice(5, 7), 16)];

    r = Math.floor(r * fator);
    g = Math.floor(g * fator);
    b = Math.floor(b * fator);

    return `#${r.toString(16).padStart(2, '0')}${g.toString(16).padStart(2, '0')}${b.toString(16).padStart(2, '0')}`;
  }

  clarearCor(hex, fator) {
    if (hex.includes('gradient')) return hex;

    let [r, g, b] = [parseInt(hex.slice(1, 3), 16), parseInt(hex.slice(3, 5), 16), parseInt(hex.slice(5, 7), 16)];

    r = Math.min(255, Math.floor(r / fator));
    g = Math.min(255, Math.floor(g / fator));
    b = Math.min(255, Math.floor(b / fator));

    return `#${r.toString(16).padStart(2, '0')}${g.toString(16).padStart(2, '0')}${b.toString(16).padStart(2, '0')}`;
  }

  hexToRgba(hex, alpha) {
    if (hex.includes('gradient')) return hex;

    let [r, g, b] = [parseInt(hex.slice(1, 3), 16), parseInt(hex.slice(3, 5), 16), parseInt(hex.slice(5, 7), 16)];
    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
  }

  isColorLight(hex) {
    if (hex.includes('gradient')) return true;

    let [r, g, b] = [parseInt(hex.slice(1, 3), 16), parseInt(hex.slice(3, 5), 16), parseInt(hex.slice(5, 7), 16)];

    r /= 255;
    g /= 255;
    b /= 255;

    let luminancia = (0.299 * r + 0.587 * g + 0.114 * b);

    return luminancia > 0.5;
  }

  hexToHSL(H: string): [number, number, number] {
    let r: number = 0, g: number = 0, b: number = 0;
    if (H.length === 4) {
      r = parseInt(H[1] + H[1], 16);
      g = parseInt(H[2] + H[2], 16);
      b = parseInt(H[3] + H[3], 16);
    } else if (H.length === 7) {
      r = parseInt(H[1] + H[2], 16);
      g = parseInt(H[3] + H[4], 16);
      b = parseInt(H[5] + H[6], 16);
    }

    r = r / 255;
    g = g / 255;
    b = b / 255;

    let max = Math.max(r, g, b), min = Math.min(r, g, b);
    let h = 0, s = 0, l = (max + min) / 2;

    if (max === min) {
      h = 0;
      s = 0;
    } else {
      let d = max - min;
      s = l > 0.5 ? d / (2 - max - min) : d / (max + min);

      switch (max) {
        case r: h = (g - b) / d + (g < b ? 6 : 0); break;
        case g: h = (b - r) / d + 2; break;
        case b: h = (r - g) / d + 4; break;
      }

      h /= 6;
    }
    return [Math.round(h * 360), Math.round(s * 100), Math.round(l * 100)];
  }

  hslToHex(h: number, s: number, l: number): string {
    h /= 360;
    s /= 100;
    l /= 100;
    let r, g, b;

    if (s === 0) {
      r = g = b = l;
    } else {
      const hue2rgb = (p, q, t) => {
        if (t < 0) t += 1;
        if (t > 1) t -= 1;
        if (t < 1 / 6) return p + (q - p) * 6 * t;
        if (t < 1 / 2) return q;
        if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
        return p;
      };
      const q = l < 0.5 ? l * (1 + s) : l + s - l * s;
      const p = 2 * l - q;
      r = hue2rgb(p, q, h + 1 / 3);
      g = hue2rgb(p, q, h);
      b = hue2rgb(p, q, h - 1 / 3);
    }
    const toHex = x => {
      const hex = Math.round(x * 255).toString(16);
      return hex.length === 1 ? '0' + hex : hex;
    };
    return '#' + toHex(r) + toHex(g) + toHex(b);
  }

  generateColorPalette(hex1: string, hex2: string = null): string[] {
    let palette = [];
    let hsl1 = this.hexToHSL(hex1);
    if (hex2 === null) {
      palette.push(this.hslToHex((hsl1[0] + 180) % 360, hsl1[1], hsl1[2]));
      palette.push(this.hslToHex((hsl1[0] + 30) % 360, hsl1[1], hsl1[2]));
      palette.push(this.hslToHex((hsl1[0] - 30 + 360) % 360, hsl1[1], hsl1[2]));
      palette.push(this.hslToHex((hsl1[0] + 150) % 360, hsl1[1], hsl1[2]));
      palette.push(this.hslToHex((hsl1[0] - 150 + 360) % 360, hsl1[1], hsl1[2]));
    } else {
      let hsl2 = this.hexToHSL(hex2);
      palette.push(this.hslToHex((hsl1[0] + hsl2[0]) / 2, (hsl1[1] + hsl2[1]) / 2, (hsl1[2] + hsl2[2]) / 2));
      palette.push(this.hslToHex((hsl1[0] + 30) % 360, hsl1[1], hsl1[2]));
      palette.push(this.hslToHex((hsl1[0] - 30 + 360) % 360, hsl1[1], hsl1[2]));
      palette.push(this.hslToHex((hsl2[0] + 30) % 360, hsl2[1], hsl2[2]));
      palette.push(this.hslToHex((hsl2[0] - 30 + 360) % 360, hsl2[1], hsl2[2]));
    }
    palette.unshift(hex1);
    if (hex2 !== null) palette.push(hex2);
    return palette;
  }

  generateMonoColorPalette(hex1: string): string[] {
    const generateShade = (hsl: number[], lightnessAdjustment: number) => {
      const newLightness = Math.min(Math.max(hsl[2] + lightnessAdjustment, 0), 100);
      return this.hslToHex(hsl[0], hsl[1], newLightness);
    };

    let palette = [hex1];
    let hsl1 = this.hexToHSL(hex1);

    palette.push(generateShade(hsl1, 10));
    palette.push(generateShade(hsl1, -10));
    palette.push(generateShade(hsl1, 20));
    palette.push(generateShade(hsl1, -20));
    palette.push(generateShade(hsl1, 30));
    palette.push(generateShade(hsl1, -30));

    return palette;
  }
}
